module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.DialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.DialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学员ID:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.BabyId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学员姓名:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.BabyName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.SchoolName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单家长:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.UserName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "家长电话:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.UserTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单时间:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货状态:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.SendStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐配套实物详情:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "data": _vm.form.ProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "商品数量"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6106b75f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Family/NoPayOrderList/viewDialog/index.vue
// module id = 1501
// module chunks = 1